import { createBrowserHistory } from 'history';

// How does history work? https://blog.pshrmn.com/entry/a-little-bit-of-history/
// https://medium.freecodecamp.org/you-might-not-need-react-router-38673620f3d

const history = createBrowserHistory(); 

export default history;
